(function () {
  "use strict";
  var doc = document;
  var reduced =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function each(list, fn) {
    for (var i = 0; i < list.length; i += 1) fn(list[i], i);
  }
  function build(root) {
    var rail = root.querySelector('[role="tablist"]');
    var pill = root.querySelector(".xg-pill");
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    if (!rail || !tabs.length) return null;
    var panels = tabs.map(function (t) {
      return doc.getElementById(t.getAttribute("aria-controls") || "");
    });
    function placePill() {
      if (!pill) return;
      var active = tabs[current()];
      if (!active) return;
      var w = active.offsetWidth;
      var x = active.offsetLeft - tabs[0].offsetLeft;
      rail.style.setProperty("--xg-pill-w", w + "px");
      rail.style.setProperty("--xg-pill-x", x + "px");
    }
    function current() {
      for (var i = 0; i < tabs.length; i += 1) {
        if (tabs[i].getAttribute("aria-selected") === "true") return i;
      }
      return 0;
    }
    function select(index, moveFocus) {
      var i = (index + tabs.length) % tabs.length;
      each(tabs, function (tab, n) {
        var on = n === i;
        tab.setAttribute("aria-selected", on ? "true" : "false");
        tab.tabIndex = on ? 0 : -1;
        if (panels[n]) panels[n].hidden = !on;
      });
      placePill();
      if (moveFocus) {
        tabs[i].focus();
        tabs[i].scrollIntoView({
          inline: "nearest",
          block: "nearest",
          behavior: reduced ? "instant" : "smooth"
        });
      }
      root.dispatchEvent(
        new CustomEvent("xg:tabchange", {
          bubbles: true,
          detail: { index: i, tab: tabs[i], panel: panels[i] }
        })
      );
    }
    each(tabs, function (tab, i) {
      tab.addEventListener("click", function () {
        select(i, false);
      });
    });
    rail.addEventListener("keydown", function (event) {
      var i = current();
      var key = event.key;
      if (key === "ArrowRight") select(i + 1, true);
      else if (key === "ArrowLeft") select(i - 1, true);
      else if (key === "Home") select(0, true);
      else if (key === "End") select(tabs.length - 1, true);
      else return;
      event.preventDefault();
    });
    each(tabs, function (tab, n) {
      tab.tabIndex = n === current() ? 0 : -1;
      if (panels[n]) panels[n].hidden = n !== current();
    });
    placePill();
    rail.setAttribute("data-xg-ready", "");
    return placePill;
  }
  var placers = [];
  function prune() {
    for (var i = placers.length - 1; i >= 0; i -= 1) {
      if (!doc.contains(placers[i].root)) placers.splice(i, 1);
    }
  }
  function init(scope) {
    prune();
    each((scope || doc).querySelectorAll("[data-xg-tabs]"), function (root) {
      if (root.hasAttribute("data-xg-tabs-ready")) return;
      root.setAttribute("data-xg-tabs-ready", "");
      var place = build(root);
      if (place) placers.push({ root: root, place: place });
    });
  }
  function replace() {
    prune();
    for (var i = 0; i < placers.length; i += 1) placers[i].place();
  }
  init(doc);
  doc.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
  doc.addEventListener("shopify:section:unload", prune);
  var queued = false;
  window.addEventListener(
    "resize",
    function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        replace();
      });
    },
    { passive: true }
  );
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(replace);
  window.XG = window.XG || {};
  window.XG.tabs = {
    init: init,
    reposition: replace,
    live: function () { prune(); return placers.length; }
  };
})();
